/*
 * Mo'Stò — Article enhancements
 * - Sostituisce <aside class="routine-mosto"> con grid card prodotto
 * - Genera TOC sticky sidebar dagli H2/H3 dell'articolo
 * - Highlight TOC link in base allo scroll
 */
(function () {
  'use strict';

  // ============ ROUTINE MOSTO → PRODUCT CARDS ============
  async function transformRoutineBlocks() {
    const blocks = document.querySelectorAll('.article-mosto .routine-mosto');
    if (!blocks.length) return;

    for (const aside of blocks) {
      // Estrai info dai link e dal contesto
      const items = Array.from(aside.querySelectorAll('li, p')).filter(el =>
        el.querySelector('a[href*="/products/"]')
      );

      const productData = [];
      for (const item of items) {
        const link = item.querySelector('a[href*="/products/"]');
        if (!link) continue;
        const href = link.getAttribute('href');
        const handle = href.replace(/.*\/products\//, '').split(/[\/?#]/)[0];
        if (!handle) continue;

        // Estrai badge (testo prima del primo link, tipo "1-2 volte a settimana")
        let badge = '';
        const strongBefore = item.querySelector('strong');
        if (strongBefore && strongBefore.previousSibling == null && strongBefore.textContent) {
          badge = strongBefore.textContent.trim().replace(/[:：]$/, '');
        } else {
          // fallback: testo prima del link
          const textNodes = [];
          for (const child of item.childNodes) {
            if (child === link) break;
            if (child.nodeType === 3) textNodes.push(child.textContent);
            else if (child.nodeType === 1 && !child.matches('a[href*="/products/"]')) textNodes.push(child.textContent);
          }
          badge = textNodes.join('').trim().replace(/[:：]$/, '');
        }

        // Fetch product data
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) {
            console.warn(`[Mo'Stò routine] Product ${handle} fetch failed`);
            continue;
          }
          const p = await res.json();
          productData.push({ handle, product: p, badge });
        } catch (e) {
          console.warn(`[Mo'Stò routine] fetch error ${handle}:`, e);
        }
      }

      if (!productData.length) continue;

      // Conserva intro + heading
      const heading = aside.querySelector('h3');
      const intro = aside.querySelector(':scope > p');
      const headingHtml = heading ? heading.outerHTML : '<h3>La routine Mo\'Stò</h3>';
      const introHtml = intro ? intro.outerHTML : '';

      // Build grid
      const moneyFormat = (cents) => {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
        }).format(cents / 100);
      };

      const cardsHtml = productData
        .map(({ handle, product, badge }) => {
          const imgSrc = product.featured_image
            ? `https:${product.featured_image.replace(/^https?:/, '')}`
            : product.images?.[0] || '';
          const imgSrcSized = imgSrc.replace(/(\.(jpg|jpeg|png|webp))/i, '_400x$1');
          const firstVariant = product.variants?.[0];
          const variantId = firstVariant?.id;
          const available = firstVariant?.available !== false;

          return `
            <article class="routine-card">
              <a href="/products/${handle}" class="routine-card__media" aria-label="${escapeHtml(product.title)}">
                <img src="${imgSrcSized}" alt="${escapeHtml(product.title)}" loading="lazy" width="400" height="400">
              </a>
              <div class="routine-card__body">
                ${badge ? `<p class="routine-card__badge">${escapeHtml(badge)}</p>` : ''}
                <h4 class="routine-card__title"><a href="/products/${handle}">${escapeHtml(product.title)}</a></h4>
                <p class="routine-card__price">${moneyFormat(product.price)}</p>
                <button
                  class="routine-card__cta"
                  type="button"
                  data-variant-id="${variantId}"
                  ${!available ? 'disabled' : ''}>
                  ${available ? 'Aggiungi al carrello' : 'Non disponibile'}
                </button>
              </div>
            </article>
          `;
        })
        .join('');

      aside.innerHTML = `${headingHtml}${introHtml}<div class="routine-grid">${cardsHtml}</div>`;

      // Attach add-to-cart handlers
      aside.querySelectorAll('.routine-card__cta[data-variant-id]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Aggiungo...';
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
            });
            btn.textContent = '✓ Aggiunto';
            // Trigger Shopify Dawn cart update if available
            if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sectionRenderingScope) {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            // Update header cart count
            try {
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              const cartCount = document.querySelector('.cart-count-bubble span:not(.visually-hidden)');
              if (cartCount) cartCount.textContent = cart.item_count;
              const bubble = document.querySelector('.cart-count-bubble');
              if (bubble && cart.item_count > 0) bubble.style.display = '';
            } catch (e) {}
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1800);
          } catch (err) {
            btn.textContent = 'Errore — riprova';
            btn.disabled = false;
            console.error('add to cart failed', err);
          }
        });
      });
    }
  }

  function escapeHtml(s) {
    if (typeof s !== 'string') return '';
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ============ TOC GENERATION ============
  function buildToc() {
    const content = document.querySelector('.article-mosto__content');
    const tocList = document.querySelector('.article-mosto__toc ol');
    const tocEl = document.querySelector('.article-mosto__toc');
    const layoutEl = document.querySelector('.article-mosto__layout');
    if (!content) return;

    const headings = content.querySelectorAll('h2, h3');
    if (!headings.length) {
      // FIX: rimuovi proprio il TOC dal DOM (non solo display:none) per evitare
      // che il grid track resti allocato e il contenuto scivoli nella colonna stretta.
      // Aggiungi anche classe sul layout per passare a single column.
      if (tocEl) tocEl.remove();
      if (layoutEl) layoutEl.classList.add('article-mosto__layout--no-toc');
      return;
    }
    if (!tocList) return;

    headings.forEach((h, i) => {
      if (!h.id) {
        h.id = 'sec-' + (h.textContent || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '') + '-' + i;
      }
      const li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'is-h3' : 'is-h2';
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.dataset.target = h.id;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    // Scroll-spy: highlight active heading
    const links = tocList.querySelectorAll('a');
    const headingMap = new Map();
    links.forEach((a) => headingMap.set(a.dataset.target, a));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            links.forEach((a) => a.classList.remove('is-active'));
            const active = headingMap.get(entry.target.id);
            if (active) active.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-100px 0px -60% 0px', threshold: 0 }
    );
    headings.forEach((h) => observer.observe(h));
  }

  // ============ INIT ============
  function init() {
    transformRoutineBlocks();
    buildToc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
